export class TwoDVector3 {
    constructor(x,y,z) {
        this.name = '2dTransform';
        this.parent = null;
        this.x = x;
        this.y = y;
        this.z = z;
    }
}

export class TwoDTransform {
    constructor() {
        this.name = '2dTransform';
        this.parent = null;
        this.position = new TwoDVector3(0,0,0);
    }
}
